/** Tiempo mostrando celebración antes de avanzar de paso. */
export const GYM_STEP_SUCCESS_MS = 1_650;

/** Pausa extra tras ocultar el mensaje (respirar entre peticiones). */
export const GYM_STEP_BREATHE_MS = 950;

export const GYM_STEP_ADVANCE_TOTAL_MS = GYM_STEP_SUCCESS_MS + GYM_STEP_BREATHE_MS;

/** Estabilidad mínima del pitch antes de validar. */
export const GYM_AUDIO_HOLD_MS = 320;
